import { Alert } from 'components';
import { Flex } from 'ui';

type TextErrorProps = {
  children: string;
};

export const TextError = ({ children }: TextErrorProps) => {
  return (
    <Flex justifyContent="center">
      <Alert type="error">{children}</Alert>
    </Flex>
  );
};
